module.exports = __webpack_public_path__ + "fd9116d4ff023a2caf47b722c5578320.svg";